module.exports = __webpack_public_path__ + "img/RCloudMySQL.e2ade37d.png";